export default __webpack_public_path__ + "static/media/group1.8e956e0a.png";